import React from "react";

const Pagination = ({ page, pages, handlePreviousPage, handleNextPage }) => {
  return (
    <div className="pagination-button d-flex justify-content-center align-items-center my-4">
      {/* Previous button */}
      <span className="me-2">
        <button
          className="btn btn-primary btn-sm d-flex align-items-center justify-content-between"
          onClick={handlePreviousPage}
          disabled={page === 1}
        >
          <i className="fa fa-arrow-left ms-2"></i>
          Previous
        </button>
      </span>

      {/* Current page status */}
      <span className="mx-3">
        Page {page} of {pages}
      </span>

      {/* Next button */}
      <span>
        <button
          className="btn btn-primary btn-sm d-flex align-items-center justify-content-between"
          onClick={handleNextPage}
          disabled={page === pages} 
        >
          Next
          <i className="fa fa-arrow-right mx-2"></i>
        </button>
      </span>
    </div>
  );
};

export default Pagination;
